import React from 'react';
import PropTypes from 'prop-types';

import withWebView from 'ggApp/shared/hocs/withWebView';

import { Wrap, Top, Bottom } from './styled';

const TopWithChecker = withWebView(Top);

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            shouldShowMenu: false,
        };
    }

    showMenu = () => {
        this.setState({
            shouldShowMenu: true,
        });
    };

    closeMenu = () => {
        this.setState({
            shouldShowMenu: false,
        });
    };

    toggleMenu = () => {
        this.setState((prevState) => ({
            shouldShowMenu: !prevState.shouldShowMenu,
        }));
    };

    render() {
        const { isLoggedIn, headerRef, isDesktopUser, isTransparent, className } = this.props;
        const { shouldShowMenu } = this.state;
        return (
            <Wrap className={className} shouldShowMenu={shouldShowMenu} ref={headerRef}>
                <TopWithChecker
                    isDesktopUser={isDesktopUser}
                    isTransparent={isTransparent}
                    isLoggedIn={isLoggedIn}
                />
                <Bottom
                    shouldShowMenu={shouldShowMenu}
                    isTransparent={isTransparent}
                    showMenu={this.showMenu}
                    closeMenu={this.closeMenu}
                    toggleMenu={this.toggleMenu}
                />
            </Wrap>
        );
    }
}

Header.propTypes = {
    isLoggedIn: PropTypes.bool,
    isDesktopUser: PropTypes.bool,
    headerRef: PropTypes.func,
};

Header.defaultProps = {
    isLoggedIn: false,
    isDesktopUser: true,
    headerRef: () => {},
};

export default Header;
